import { render } from "./CopyNeeds.vue?vue&type=template&id=5f9a250e"
import script from "./CopyNeeds.vue?vue&type=script&lang=js"
export * from "./CopyNeeds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__